import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import AppContext from '../contextProvider/AppContextProvider/AppContext';
import globalStyles from '../../../theme/GlobalCss';
import { useDispatch, useSelector } from 'react-redux';
import { AuhMethods } from '../../../services/auth';
import { CurrentAuthMethod } from '../../constants/AppConstants';
import { LAYOUT_TYPES, SIDEBAR_TYPE, THEME_TYPES } from '../../constants/ThemeOptions';
import VerticalDefault from './VerticalLayouts/VerticalDefault';
import VerticalMinimal from './VerticalLayouts/VerticalMinimal';
import MinimalNoHeader from './VerticalLayouts/MinimalNoHeader';
import ModernSideBar from './VerticalLayouts/ModernSidebar';
import HorizontalDefault from './HorizontalLayouts/HorizontalDefault';
import HorizontalDark from './HorizontalLayouts/HorizontalDark';
import HorizontalMinimal from './HorizontalLayouts/HorizontalMinimal';
import HorizontalTopMenu from './HorizontalLayouts/HorizontalTopMenu';
import { languageData } from './partials/LanguageSwitcher/data';
import { updateLoadUser } from '../../../redux/actions/Auth';

//import { setDefaultOptions } from 'date-fns';
//import { hr } from 'date-fns/locale';

const useStyles = makeStyles(() => ({
  circularProgressRoot: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const AppLayout = ({ children }) => {
  const [showLayoutLoader, setLayoutLoader] = useState(true);
  const [userLanguage, setUserLanguage] = useState(false);
  const [userLanguage2, setUserLanguage2] = useState(false);
  const [userLanguage3, setUserLanguage3] = useState(false);
  const { layout } = useContext(AppContext);
  const { authUser, loadUser } = useSelector(({ auth }) => auth);
  const { locale, setLocale } = useContext(AppContext);
  const { pmsUrl, setPmsUrl } = useContext(AppContext);
  const { themeType, setThemeType, setTheme, sidebarType, setSidebarType } = useContext(AppContext);

  const { theme } = useContext(AppContext);
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  globalStyles();
  //  setSidebarType(SIDEBAR_TYPE.FULL);

  var activeTheme = {
    primary: theme.palette.primary.main,
    primaryDark: theme.palette.primary.dark,
    secondaryDark: theme.palette.secondary.dark,
    secondary: theme.palette.secondary.main,
    fontPrimary: theme.palette.primary.contrastText,
    fontSecondary: theme.palette.secondary.contrastText,
    header: theme.palette.header.main,
    headerDark: theme.palette.header.dark,
    headerFont: theme.palette.header.font,
  };

  const [themeColors, setThemeColors] = useState({
    primary: activeTheme.primary,
    secondary: activeTheme.secondary,
  });
  const [themeColors2, setThemeColors2] = useState({
    fontPrimary: activeTheme.fontPrimary,
    fontSecondary: activeTheme.fontSecondary,
    darkPrimary: activeTheme.primaryDark,
    darkSecondary: activeTheme.secondaryDark,
    header: activeTheme.header,
    headerDark: activeTheme.headerDark,
    headerFont: activeTheme.headerFont,
  });

  if (userLanguage == false) {
    var langId = '';
    const params = queryString.parse(window.location.search.substring(1));
    if (params != null && params.language != null) {
      langId = params.language;
    }

    if (langId != '') {
      if (langId == 'en') var item = languageData[0];
      if (langId == 'hr') var item = languageData[1];
      if (langId == 'de') var item = languageData[2];
      if (langId == 'it') var item = languageData[3];
      if (langId == 'sl') var item = languageData[4];
      if (langId == 'sr') var item = languageData[5];
      setLocale(item);
    }
  }
  useEffect(() => {
    if (location.pathname.startsWith('/pages/selfcheckin/')) {
      dispatch(updateLoadUser(true));
      //  setLayoutLoader(false);
    } else dispatch(AuhMethods[CurrentAuthMethod].getAuthUser());
    setLayoutLoader(false);
  }, []);

  useEffect(() => {
    var el = document.getElementById('root');
    if (sidebarType == SIDEBAR_TYPE.FULL)
      if (el && el.firstChild) el.firstChild.classList.remove('Cmt-miniLayout');
      else if (el && el.firstChild) el.firstChild.classList.add('Cmt-miniLayout');
  }, [sidebarType]);

  useEffect(() => {
    if (themeColors.primary !== activeTheme.primary || themeColors.secondary !== activeTheme.secondary) {
      setTheme(theme => ({
        ...theme,
        palette: {
          ...theme.palette,
          header: {
            ...theme.palette.header,
            main: themeColors2.header,
            dark: themeColors2.headerDark,
            font: themeColors2.headerFont,
          },
          primary: {
            ...theme.palette.primary,

            main: themeColors.primary,
            dark: themeColors2.darkPrimary,
            contrastText: themeColors2.fontPrimary,
          },
          secondary: {
            ...theme.palette.secondary,
            main: themeColors.secondary,
            header: themeColors2.header,
            dark: themeColors2.darkSecondary,
            contrastText: themeColors2.fontSecondary,
          },
        },
      }));
    }
  }, [themeColors, setTheme, themeType]);

  if (authUser != null && authUser.langid != null) {
    //alert(JSON.stringify(userLanguage));
    if (userLanguage2 == false) {
      var item = languageData[authUser.langid];
      setLocale(item);
      setUserLanguage2(true);
      if (authUser.darkTheme == 1) setThemeType(THEME_TYPES.DARK);
      else setThemeType(THEME_TYPES.LIGHT);
      moment.updateLocale(/*authUser.langid*/ 'en', {
        week: {
          dow: 1,
        },
      });
      //var el = document.getElementById('root');
      //console.log(el.firstChild);
      //if (el) el.firstChild.classList.remove('Cmt-miniLayout');
      //if (authUser.)
      var brandId = authUser.brandId;
      var hostName = window.location.hostname;
      if (hostName === 'app.mikos.io' || hostName === 'app.forotel.io') brandId = 1;
      if (hostName === 'book.serenahotels.com') brandId = 2;
      //      brandId = 2;

      if (brandId == 0) {
        var link = document.createElement('link'),
          oldLink = document.getElementById('dynamic-favicon');
        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = '/images/favicon1.svg';
        if (oldLink) {
          document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
      }
      if (brandId == 2) {
        setThemeColors({
          secondary: '#8f460c',
          primary: '#e17a38',
        });
        setThemeColors2({
          fontPrimary: '#ffffff',
          fontSecondary: '#50423e',
          darkPrimary: '#c7bdb3',
          darkSecondary: '#b9b2a6',
          header: '#fbf2e1',
          headerDark: '#fbf2e1',
          headerFont: '#50423e',
        });
      }
      if (brandId == 1) {
        setThemeColors({
          primary: '#145C9E',
          secondary: '#134d83',
        });
        setThemeColors2({
          header: '#145C9E',
          headerDark: '#145C9E',
          fontPrimary: activeTheme.fontPrimary,
          fontSecondary: activeTheme.fontSecondary,
          darkPrimary: activeTheme.primaryDark,
          darkSecondary: activeTheme.secondaryDark,
          headerFont: activeTheme.headerFont,
        });

        document.title = 'forotel';
        var link = document.createElement('link'),
          oldLink = document.getElementById('dynamic-favicon');
        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = '/images/favicon2.svg';
        if (oldLink) {
          document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
      } else document.title = 'WebBookingPro';

      if (authUser.clouduser == 2) {
        setThemeColors({
          primary: '#993366',
          secondary: '#cc0066',
        });
        setThemeColors2({
          header: '#993366',
          headerDark: '#993366',
          fontPrimary: activeTheme.fontPrimary,
          fontSecondary: activeTheme.fontSecondary,
          darkPrimary: activeTheme.primaryDark,
          darkSecondary: activeTheme.secondaryDark,
          headerFont: activeTheme.headerFont,
        });
        document.title = 'Milenij by WebBookingPro';
      }
    }
  } else {
    if (userLanguage3 == false) {
      setUserLanguage3(true);
      var brandId = 0;
      var hostName = window.location.hostname;
      if (hostName === 'app.mikos.io' || hostName === 'app.forotel.io') brandId = 1;
      if (hostName === 'book.serenahotels.com') brandId = 2;
      //  brandId = 2;
      if (brandId == 0) {
        var link = document.createElement('link'),
          oldLink = document.getElementById('dynamic-favicon');
        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = '/images/favicon1.svg';
        if (oldLink) {
          document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
      }
      if (brandId == 2) {
        setThemeColors({
          secondary: '#8f460c',
          primary: '#e17a38',
        });
        setThemeColors2({
          fontPrimary: '#ffffff',
          fontSecondary: '#50423e',
          darkPrimary: '#c7bdb3',
          darkSecondary: '#b9b2a6',
          header: '#fbf2e1',
          headerDark: '#fbf2e1',
          headerFont: '#50423e',
        });
      }
      if (brandId == 1) {
        setThemeColors({
          primary: '#145C9E',
          secondary: '#134d83',
        });
        setThemeColors2({
          header: '#145C9E',
          headerDark: '#145C9E',
          fontPrimary: activeTheme.fontPrimary,
          fontSecondary: activeTheme.fontSecondary,
          darkPrimary: activeTheme.primaryDark,
          darkSecondary: activeTheme.secondaryDark,
          headerFont: activeTheme.headerFont,
        });

        document.title = 'forotel';
        var link = document.createElement('link'),
          oldLink = document.getElementById('dynamic-favicon');
        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = '/images/favicon2.svg';
        if (oldLink) {
          document.head.removeChild(oldLink);
        }
        document.head.appendChild(link);
      } else document.title = 'WebBookingPro';
    }
  }

  if (showLayoutLoader || !loadUser) {
    return (
      <div className={classes.circularProgressRoot}>
        <CircularProgress />
      </div>
    );
  }

  if (
    [
      '/passwordChange',
      '/signin',
      '/signup',
      '/signuptravel',
      '/forgot-password',
      '/mobile',
      '/pages/shiftplanner',
      '/gastromobile',
    ].includes(location.pathname)
  ) {
    return <div style={{ minHeight: '100vh', width: '100%', display: 'flex' }}>{children}</div>;
  }
  if (location.pathname.substring(0, 18) == '/pages/selfcheckin')
    return <div style={{ minHeight: '100vh', width: '100%', display: 'flex' }}>{children}</div>;

  switch (layout) {
    case LAYOUT_TYPES.VERTICAL_DEFAULT: {
      return <VerticalDefault children={children} />;
    }
    case LAYOUT_TYPES.VERTICAL_MINIMAL: {
      return <VerticalMinimal children={children} />;
    }
    case LAYOUT_TYPES.VERTICAL_MINIMAL_NO_HEADER: {
      return <MinimalNoHeader children={children} />;
    }
    case LAYOUT_TYPES.VERTICAL_MODERN_SIDEBAR: {
      return <ModernSideBar children={children} />;
    }
    case LAYOUT_TYPES.HORIZONTAL_DEFAULT: {
      return <HorizontalDefault children={children} />;
    }
    case LAYOUT_TYPES.HORIZONTAL_DARK: {
      return <HorizontalDark children={children} />;
    }
    case LAYOUT_TYPES.HORIZONTAL_MINIMAL: {
      return <HorizontalMinimal children={children} />;
    }
    case LAYOUT_TYPES.HORIZONTAL_TOP_MENU: {
      return <HorizontalTopMenu children={children} />;
    }
    default:
      return <VerticalDefault children={children} />;
  }
};

export default AppLayout;
